/*
 * CandyPeak Animation Engine
 * Version 1.3.0
 */

(function () {
  'use strict';

  var activeElement = null;

  var CandyPeakEngine = {
    version: '1.3.0',

    settings: {
      debug: window.location.search.indexOf('cpdebug=1') !== -1,

      pressSelector: [
        'button',
        '.button',
        'a.button',
        '.shopify-payment-button__button',
        '.product-card-wrapper',
        '.card-wrapper',
        '.cplus-category-card',
        '[data-cp-press]'
      ].join(','),

      revealSelector: [
        'main .shopify-section',
        'main [data-cp-reveal]'
      ].join(',')
    },

    init: function () {
      document.documentElement.classList.add('cp-engine-active');

      this.injectStyles();

      this.preparePressElements();
      this.initPressAnimations();
      this.observeNewPressElements();

      this.initScrollReveal();

      this.showDebugBadge();

      console.log(
        'CandyPeak Animation Engine v' +
          this.version +
          ' erfolgreich gestartet'
      );
    },

    injectStyles: function () {
      if (document.getElementById('cp-engine-styles')) {
        return;
      }

      var style = document.createElement('style');

      style.id = 'cp-engine-styles';

      style.textContent = `
        /*
         * PRESS-EFFEKT
         */

        .cp-press-ready {
          transform-origin: center center;
          transition:
            transform 200ms cubic-bezier(0.22, 1, 0.36, 1),
            filter 200ms ease;
          -webkit-tap-highlight-color: transparent;
        }

        .cp-press-ready.cp-press-active {
          transform:
            translate3d(0, -2px, 0)
            scale(0.97) !important;

          filter: brightness(0.985);
          transition-duration: 80ms !important;
        }

        .cp-press-ready.cp-press-release {
          animation:
            cp-soft-bounce
            260ms
            cubic-bezier(0.22, 1, 0.36, 1);
        }

        @keyframes cp-soft-bounce {
          0% {
            transform:
              translate3d(0, -2px, 0)
              scale(0.97);
          }

          60% {
            transform:
              translate3d(0, -1px, 0)
              scale(1.01);
          }

          100% {
            transform:
              translate3d(0, 0, 0)
              scale(1);
          }
        }

        @media (hover: hover) and (pointer: fine) {
          .cp-press-ready:hover {
            transform:
              translate3d(0, -3px, 0)
              scale(1.006);
          }

          .cp-press-ready.cp-press-active:hover {
            transform:
              translate3d(0, -1px, 0)
              scale(0.97) !important;
          }
        }

        /*
         * SCROLL-REVEAL
         */

        .cp-reveal-ready {
          opacity: 0;
          transform: translate3d(0, 12px, 0);

          transition:
            opacity 220ms ease,
            transform 260ms cubic-bezier(0.22, 1, 0.36, 1);

          transition-delay: var(--cp-reveal-delay, 0ms);
        }

        .cp-reveal-ready.cp-reveal-visible {
          opacity: 1;
          transform: none;
        }

        /*
         * REDUZIERTE BEWEGUNGEN
         */

        @media (prefers-reduced-motion: reduce) {
          .cp-press-ready,
          .cp-press-ready.cp-press-active,
          .cp-press-ready.cp-press-release,
          .cp-reveal-ready,
          .cp-reveal-ready.cp-reveal-visible {
            animation: none !important;
            transition: none !important;
            transform: none !important;
            filter: none !important;
            opacity: 1 !important;
          }
        }
      `;

      document.head.appendChild(style);
    },

    /*
     * PRESS-EFFEKT
     */

    preparePressElement: function (element) {
      if (!element || !element.classList) {
        return;
      }

      if (element.closest('[data-cp-no-animation]')) {
        return;
      }

      element.classList.add('cp-press-ready');
    },

    preparePressElements: function () {
      var elements = document.querySelectorAll(
        this.settings.pressSelector
      );

      for (var i = 0; i < elements.length; i++) {
        this.preparePressElement(elements[i]);
      }
    },

    initPressAnimations: function () {
      var self = this;
      var selector = this.settings.pressSelector;

      document.addEventListener(
        'pointerdown',
        function (event) {
          var target = event.target;

          if (!target || typeof target.closest !== 'function') {
            return;
          }

          var element = target.closest(selector);

          if (!element) {
            return;
          }

          if (element.closest('[data-cp-no-animation]')) {
            return;
          }

          self.preparePressElement(element);

          element.classList.remove('cp-press-release');
          element.classList.add('cp-press-active');

          activeElement = element;
        },
        { passive: true }
      );

      function releaseActiveElement() {
        if (!activeElement) {
          return;
        }

        var element = activeElement;
        activeElement = null;

        element.classList.remove('cp-press-active');
        element.classList.remove('cp-press-release');

        element.classList.add('cp-press-release');

        window.setTimeout(function () {
          element.classList.remove('cp-press-release');
        }, 280);
      }

      document.addEventListener(
        'pointerup',
        releaseActiveElement,
        { passive: true }
      );

      document.addEventListener(
        'pointercancel',
        releaseActiveElement,
        { passive: true }
      );

      window.addEventListener(
        'blur',
        releaseActiveElement
      );
    },

    observeNewPressElements: function () {
      var self = this;

      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var addedNodes = mutations[i].addedNodes;

          for (var j = 0; j < addedNodes.length; j++) {
            var node = addedNodes[j];

            if (!node || node.nodeType !== 1) {
              continue;
            }

            if (node.matches(self.settings.pressSelector)) {
              self.preparePressElement(node);
            }

            var children = node.querySelectorAll(
              self.settings.pressSelector
            );

            for (var k = 0; k < children.length; k++) {
              self.preparePressElement(children[k]);
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    /*
     * SCROLL-REVEAL
     */

    initScrollReveal: function () {
      var elements = document.querySelectorAll(
        this.settings.revealSelector
      );

      if (!elements.length) {
        return;
      }

      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        for (var fallbackIndex = 0;
          fallbackIndex < elements.length;
          fallbackIndex++
        ) {
          elements[fallbackIndex].classList.add(
            'cp-reveal-visible'
          );
        }

        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];

            if (!entry.isIntersecting) {
              continue;
            }

            entry.target.classList.add(
              'cp-reveal-visible'
            );

            observer.unobserve(entry.target);
          }
        },
        {
          threshold: 0.01,
          rootMargin: '160px 0px'
        }
      );

      var visibleElements = new WeakSet();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      for (var visibleIndex = 0; visibleIndex < elements.length; visibleIndex++) {
        var bounds = elements[visibleIndex].getBoundingClientRect();
        if (bounds.top < viewportHeight + 160 && bounds.bottom >= -160) {
          visibleElements.add(elements[visibleIndex]);
        }
      }

      for (var index = 0; index < elements.length; index++) {
        var element = elements[index];

        if (
          element.matches('.section-cp-mystery-box-showcase, .section-cp-tiktok-viral') ||
          element.closest('[data-cp-no-animation]') ||
          element.classList.contains('cp-reveal-ready')
        ) {
          continue;
        }

        if (visibleElements.has(element)) {
          element.classList.add('cp-reveal-visible');
          continue;
        }

        element.classList.add('cp-reveal-ready');

        element.style.setProperty(
          '--cp-reveal-delay',
          Math.min(index % 3, 2) * 15 + 'ms'
        );

        observer.observe(element);
      }
    },

    /*
     * DEBUG-BADGE
     */

    showDebugBadge: function () {
      var shopifyDesignMode =
        typeof window.Shopify !== 'undefined' &&
        window.Shopify.designMode === true;

      if (!this.settings.debug && !shopifyDesignMode) {
        return;
      }

      if (document.getElementById('cp-engine-debug')) {
        return;
      }

      var badge = document.createElement('div');

      badge.id = 'cp-engine-debug';
      badge.textContent =
        'CandyPeak Engine v' +
        this.version +
        ' aktiv';

      badge.style.position = 'fixed';
      badge.style.left = '12px';
      badge.style.bottom = '12px';
      badge.style.zIndex = '2147483647';
      badge.style.padding = '9px 13px';
      badge.style.borderRadius = '999px';
      badge.style.background = '#ff2f92';
      badge.style.color = '#ffffff';
      badge.style.fontFamily = 'Arial, sans-serif';
      badge.style.fontSize = '12px';
      badge.style.fontWeight = '700';
      badge.style.boxShadow =
        '0 8px 25px rgba(0, 0, 0, 0.18)';
      badge.style.pointerEvents = 'none';

      document.body.appendChild(badge);
    }
  };

  window.CandyPeakEngine = CandyPeakEngine;

  function startCandyPeakEngine() {
    CandyPeakEngine.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startCandyPeakEngine
    );
  } else {
    startCandyPeakEngine();
  }
})();

